
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import editableInput from 'vue-color/src/components/common/EditableInput.vue';

@Component({
   components: {
      'ed-in': editableInput,
   },
})
export default class ColorCompactPallet extends Vue {
   @Prop({ type: [Array, Object, String], default: '' }) value!: any[] | any | string;

   @Prop({ type: Array }) palette!: string[];

   @Prop({ type: String, default: '' }) reset_color!: string;

   colors: any[] = [];

   mounted(): void {
      this.onChangeValue();
   }

   handlerClick(c: string) {
      const values = Array.isArray(this.value) ? this.value : [this.value];
      const palette = this.palette.filter(hex => hex.toUpperCase() != this.reset_color.toUpperCase());

      if (c == this.reset_color || (c == 'all' && values.length == palette.length)) {
         this.$emit('input', [{ hex: this.reset_color.toUpperCase() }]);
         return;
      }

      let colors = values
         .map(c => ({
            hex: (typeof c == 'string' ? c : c.hex).toUpperCase(),
         }))
         .filter(({ hex }) => hex.toUpperCase() != this.reset_color.toUpperCase());

      if (c == 'all') {
         colors = palette.map(c => ({ hex: c }));
      } else if (colors.filter(({ hex }) => hex == c).length) {
         colors = colors.filter(({ hex }) => hex != c);
      } else {
         colors = [...colors, { hex: c }];
      }

      this.$emit('input', colors);
   }

   @Watch('value')
   onChangeValue() {
      this.colors = (Array.isArray(this.value) ? this.value : [this.value]).map(c => ({
         hex: (typeof c == 'string' ? c : c.hex)?.toUpperCase(),
      }));
   }
}
